import { motion } from 'framer-motion';
import { gEnums } from 'global/enums/globalEnums';
import Wrapper from 'global/wrappers/Wrapper';
import { createContext, useEffect, useState } from 'react';
import { _swiperMenuTypes, SwiperMenu } from './SwiperMenu';

export const MiniSwiperContext = createContext();

export const MiniSwiper = ({
  swipeItems,
  className = '',
}) => {

  const [activeIndex, setActiveIndex] = useState(0);
  const [activeSwipeItemKey, setActiveSwipeItemKey] = useState();

  useEffect(() => {
    // setActiveSwipeItemKey(swipeItems?.[0]?.key)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [swipeItems]);

  const handleIndexChange = (index) => {
    setActiveIndex(index);
    // setActiveSwipeItemKey(swipeItems?.[index]?.key);
  };

  const header = <SwiperMenu
    swipeContentType={gEnums.swipeContentTypes.normalItems}
    menuItems={swipeItems}
    swiperMenuType={_swiperMenuTypes.buttons}
    activeIndex={activeIndex}
    handleIndexChange={handleIndexChange}
  />

  const content = <div className={`mini-swiper ${className}`} style={{ position: 'relative', overflow: 'hidden' }}>
    {swipeItems.map((item, index) => (
      <motion.div
        key={index}
        initial={false}
        animate={{ opacity: activeIndex === index ? 1 : 0 }}
        transition={{ duration: 0.15, ease: 'easeInOut' }}
        style={{
          position: activeIndex === index ? 'relative' : 'absolute',
          width: '100%',
          pointerEvents: activeIndex === index ? 'auto' : 'none'
        }}
      >
        {item ? item.content : <div>---</div>}
      </motion.div>
    ))}
  </div>

  return (
    <MiniSwiperContext.Provider value={{ miniSwiper_state: { activeIndex, activeSwipeItemKey } }}>
      <Wrapper
        header={header}
        content={content}
      />
    </MiniSwiperContext.Provider>
  )
} 